import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { style: {"width":"80vw"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn_back = _resolveComponent("v-btn-back")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_VATDeclarationDetailCardAssist = _resolveComponent("VATDeclarationDetailCardAssist")!
  const _component_VATDeclarationDetailCardAuto = _resolveComponent("VATDeclarationDetailCardAuto")!
  const _component_VATDeclarationSummaryCard = _resolveComponent("VATDeclarationSummaryCard")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_DeclarationManager = _resolveComponent("DeclarationManager")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    fluid: "",
    class: "pa-2 pr-0 pb-1",
    style: _normalizeStyle(_ctx.$vuetify.display.mobile ? 'width: 100vw;' : '')
  }, {
    default: _withCtx(() => [
      (!_ctx.$vuetify.display.mobile)
        ? (_openBlock(), _createBlock(_component_v_window, {
            key: 0,
            modelValue: _ctx.globalStep,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.globalStep) = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_window_item, { value: 0 }, {
                default: _withCtx(() => [
                  (_ctx.loading)
                    ? (_openBlock(), _createBlock(_component_v_row, {
                        key: 0,
                        "no-gutters": ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "12",
                            class: "d-flex justify-center align-center"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_progress_circular, {
                                indeterminate: "",
                                color: "primary"
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createVNode(_component_v_row, {
                          "no-gutters": "",
                          class: "my-2"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, { cols: "6" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn_back, {
                                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.back()), ["stop"]))
                                }),
                                (_ctx.hasAlreadyDeclaredItems)
                                  ? (_openBlock(), _createBlock(_component_v_btn, {
                                      key: 0,
                                      size: "small",
                                      class: "ml-2",
                                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.confirmVatItemsAlreadyDeclaredDialog = true))
                                    }, {
                                      default: _withCtx(() => _cache[10] || (_cache[10] = [
                                        _createTextVNode("Eléments déjà déclarés")
                                      ])),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, {
                              cols: "6",
                              class: "d-flex justify-end pr-2"
                            }, {
                              default: _withCtx(() => [
                                (!_ctx.showSummaryPanel)
                                  ? (_openBlock(), _createBlock(_component_v_btn, {
                                      key: 0,
                                      class: "mr-2",
                                      size: "small",
                                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showSummaryPanel = true))
                                    }, {
                                      default: _withCtx(() => _cache[11] || (_cache[11] = [
                                        _createTextVNode("Afficher le récapitulatif")
                                      ])),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_v_btn, {
                                  disabled: !_ctx.needSave,
                                  class: "mr-2",
                                  size: "small",
                                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.save()))
                                }, {
                                  default: _withCtx(() => _cache[12] || (_cache[12] = [
                                    _createTextVNode("Enregistrer Assistant TVA")
                                  ])),
                                  _: 1
                                }, 8, ["disabled"]),
                                (_ctx.globalStep < 1)
                                  ? (_openBlock(), _createBlock(_component_v_btn, {
                                      key: 1,
                                      rounded: "",
                                      elevation: "0",
                                      disabled: _ctx.nextIsDisabled,
                                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.nextPage())),
                                      size: "small"
                                    }, {
                                      default: _withCtx(() => _cache[13] || (_cache[13] = [
                                        _createTextVNode("Suivant")
                                      ])),
                                      _: 1
                                    }, 8, ["disabled"]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_row, { "no-gutters": "" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: _ctx.showSummaryPanel ? 9 : 12,
                              class: "pr-2"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", null, [
                                  _createVNode(_component_VATDeclarationDetailCardAssist, {
                                    vatItems: _ctx.assistVatItemsNotAlreadyDeclared,
                                    endDate: _ctx.endDate,
                                    fromAssistVATComponent: true,
                                    isGrossAmountExceeded: _ctx.isGrossAmountExceeded,
                                    onDeleteSubOrAddedItem: _ctx.deleteItem,
                                    onAddItem: _ctx.addItem
                                  }, null, 8, ["vatItems", "endDate", "isGrossAmountExceeded", "onDeleteSubOrAddedItem", "onAddItem"])
                                ]),
                                _createElementVNode("div", null, [
                                  _createVNode(_component_VATDeclarationDetailCardAuto, {
                                    vatItems: _ctx.autoVatItemsNotAlreadyDeclared,
                                    endDate: _ctx.endDate,
                                    fromAutoVATComponent: false
                                  }, null, 8, ["vatItems", "endDate"])
                                ])
                              ]),
                              _: 1
                            }, 8, ["cols"]),
                            (_ctx.showSummaryPanel)
                              ? (_openBlock(), _createBlock(_component_v_col, {
                                  key: 0,
                                  cols: "3"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_VATDeclarationSummaryCard, {
                                      autoVatItems: _ctx.autoVatItemsNotAlreadyDeclared,
                                      assistVatItems: _ctx.assistVatItemsNotAlreadyDeclared,
                                      previousVatCredit: _ctx.previousVatCredit,
                                      noVat: _ctx.noVat,
                                      showSummaryPanel: _ctx.showSummaryPanel,
                                      onShowSummaryPanel: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showSummaryPanel = false))
                                    }, null, 8, ["autoVatItems", "assistVatItems", "previousVatCredit", "noVat", "showSummaryPanel"])
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ], 64))
                ]),
                _: 1
              }),
              _createVNode(_component_v_window_item, { value: 1 }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: "12" }, {
                        default: _withCtx(() => [
                          (_ctx.globalStep === 1 && _ctx.version === 'new')
                            ? (_openBlock(), _createBlock(_component_DeclarationManager, {
                                key: 0,
                                propsCerfaNumber: _ctx.cerfaNumber,
                                propsStartDate: _ctx.startDate,
                                propsEndDate: _ctx.endDate,
                                assistVatMode: true,
                                propsAssistVatItems: _ctx.assistVatItemsNotAlreadyDeclared,
                                propsAutoVatItems: 
                                    _ctx.autoVatItemsNotAlreadyDeclared.length
                                        ? _ctx.autoVatItemsNotAlreadyDeclared
                                        : null
                                ,
                                propsPreviousVatCredit: _ctx.previousVatCredit,
                                onBack: _cache[6] || (_cache[6] = ($event: any) => (_ctx.globalStep--)),
                                id: _ctx.declarationId || _ctx.declarationIdAfterSave
                              }, null, 8, ["propsCerfaNumber", "propsStartDate", "propsEndDate", "propsAssistVatItems", "propsAutoVatItems", "propsPreviousVatCredit", "id"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      _createVNode(_component_oss_dialog, {
        modelValue: _ctx.confirmVatItemsAlreadyDeclaredDialog,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.confirmVatItemsAlreadyDeclaredDialog) = $event)),
        onValid: _cache[9] || (_cache[9] = ($event: any) => (_ctx.vatDeclarationAlreadyDone())),
        title: "Confirmation",
        validTitle: "Confirmer"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_v_row, {
              "no-gutters": "",
              class: "d-flex justify-center"
            }, {
              default: _withCtx(() => _cache[14] || (_cache[14] = [
                _createElementVNode("b", null, " Êtes-vous sûr(e) que ces factures et/ou mouvements bancaires ont déjà été déclarés ? ", -1)
              ])),
              _: 1
            }),
            _createVNode(_component_v_row, {
              "no-gutters": "",
              class: "d-flex justify-center"
            }, {
              default: _withCtx(() => _cache[15] || (_cache[15] = [
                _createElementVNode("b", null, " Après confirmation, ces éléments ne seront plus proposés, définitivement. ", -1)
              ])),
              _: 1
            }),
            (_ctx.assistVatItemsAlreadyDeclared && _ctx.assistVatItemsAlreadyDeclared.length)
              ? (_openBlock(), _createBlock(_component_VATDeclarationDetailCardAssist, {
                  key: 0,
                  vatItems: _ctx.assistVatItemsAlreadyDeclared,
                  componentForAlreadyDeclaredItems: true
                }, null, 8, ["vatItems"]))
              : _createCommentVNode("", true),
            (_ctx.autoVatItemsAlreadyDeclared && _ctx.autoVatItemsAlreadyDeclared.length)
              ? (_openBlock(), _createBlock(_component_VATDeclarationDetailCardAuto, {
                  key: 1,
                  vatItems: _ctx.autoVatItemsAlreadyDeclared,
                  componentForAlreadyDeclaredItems: true
                }, null, 8, ["vatItems"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }, 8, ["style"]))
}